import { init as initFullStory } from "@fullstory/browser";
import "phoenix_html";
import { fetchMetaData } from "./fetchMetaData";
import { initColorScheme } from "./util/colorScheme";

initColorScheme();

document.addEventListener("DOMContentLoaded", () => {
  const fullStoryOrgId = fetchMetaData("fullStoryOrgId");
  if (fullStoryOrgId !== null) {
    initFullStory({ orgId: fullStoryOrgId });
  }
});
